import React, { useState, useRef } from "react";
import { useDebounce } from "react-use";
import { useSolrContext } from "@e-fork/solr";
import useTranslate from "@default/hooks/use-translate";
import DashedBorder from "@default/general-components/dashed-border";

const FiltersControlSearch = () => {
  const { searchQueryString, setSearchQueryString } = useSolrContext();
  const _t = useTranslate();

  const [tempSearchQueryString, setTempSearchQueryString] =
    useState(searchQueryString);

  useDebounce(
    () => {
      setSearchQueryString(tempSearchQueryString);
    },
    750,
    [tempSearchQueryString]
  );

  const onChange = (e) => {
    const value = e.target.value;
    setTempSearchQueryString(value);
  };

  return (
    <div className="filters-control-search-wrapper">
      <DashedBorder />
      <input
        id="search-input"
        tabIndex="0"
        autoComplete="off"
        placeholder={_t("search.placeholder")}
        type="search"
        name="searchString"
        onChange={onChange}
        value={tempSearchQueryString}
        onKeyPress={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      />
    </div>
  );
};

export default FiltersControlSearch;
